import styled from "styled-components"

import Card from "@irati/ui/src/Layout/Card"

interface StepProps {
  step: number
}

export const Block = styled.div`
  max-width: 900px;
  margin: 0 auto;
`

export const Background = styled.div<StepProps>`
  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    min-height: 100vh;
  `}
  padding: ${({theme}) => theme.spacing.four};
  background-color: ${({step}) => {
    switch (step) {
      case 1:
        return "#92C8FA"
      case 2:
        return "#ADE3E2"
      case 3:
        return "#ECB98C"
      case 4:
      default:
        return "#EC9FB3"
    }
  }};
  position: relative;
  overflow: hidden;
`

export const StyledCard = styled(Card)`
  position: relative;
  min-height: 400px;
  display: flex;
`

export const Gradient = styled.div<StepProps>`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 5%;
  top: 60%;
  background: ${({step}) => {
    switch (step) {
      case 1:
        return "radial-gradient(120.8% 131.78% at 61.82% 3.79%, #c4e5fd 0%, rgba(54, 4, 255, 0.61) 35.42%, #eb5372 100%)"
      case 2:
        return "radial-gradient(73.03% 71.68% at 57.79% 3.84%, #FDC4DF 0%, rgba(4, 135, 255, 0.82) 48.44%, rgba(249, 212, 20, 0.31) 100%)"
      case 3:
        return "radial-gradient(70.99% 66.3% at 61.08% 9.74%, #FDC4DF 0%, #B249AA 48.44%, rgba(249, 212, 20, 0.31) 100%)"
      case 4:
      default:
        return "radial-gradient(73.03% 71.68% at 57.79% 3.84%, #FDC4DF 0%, rgba(114, 4, 255, 0.82) 48.44%, rgba(249, 120, 20, 0.31) 100%)"
    }
  }};
  filter: blur(74px);
`

export const Img = styled.img`
  height: ${({height}) => height || 120}px;
`

export const ResponsiveWrapper = styled.div`
  flex: 1;
  min-width: 200px;
`
